import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Check, Loader2 } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LeadForm = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) {
      toast.error("Uzupełnij imię i adres e-mail");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, form);
      setDone(true);
      setForm({ name: "", email: "", message: "" });
      toast.success("Dziękujemy!", { description: "Wyślemy Ci dostęp na podany e-mail." });
    } catch (err) {
      toast.error("Coś poszło nie tak. Spróbuj ponownie.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-2xl bg-white border border-ink/10 px-5 py-4 text-ink placeholder:text-ink/35 focus:outline-none focus:ring-2 focus:ring-violet focus:border-transparent transition-shadow duration-300";

  return (
    <section id="probka" data-testid={TESTIDS.lead.section} className="py-24 lg:py-32 px-5 sm:px-8">
      <div className="mx-auto max-w-5xl relative overflow-hidden rounded-[2.5rem] bg-ink text-white px-6 sm:px-14 py-16 lg:py-20">
        <div className="pointer-events-none absolute -top-16 -right-10 h-72 w-72 rounded-full bg-violet/40 blur-[100px]" />
        <div className="pointer-events-none absolute -bottom-20 -left-10 h-72 w-72 rounded-full bg-blush/30 blur-[100px]" />

        <div className="relative grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <p className="text-sm tracking-widest uppercase text-violet-soft font-600">Darmowa próbka</p>
            <h2 className="mt-4 font-display font-700 text-4xl sm:text-5xl tracking-tighter leading-[1.05]">
              Odbierz pierwszy rozdział za darmo
            </h2>
            <p className="mt-5 text-white/60 text-lg leading-relaxed">
              Zostaw e-mail, a wyślę Ci pierwszy rozdział e-booka
              „Jak rozpoznać autyzm". Zero spamu, tylko wartościowe materiały.
            </p>
          </Reveal>

          <Reveal delay={0.12}>
            {done ? (
              <div
                data-testid="lead-success"
                className="rounded-3xl bg-white/10 border border-white/15 p-10 text-center"
              >
                <div className="mx-auto grid place-items-center h-14 w-14 rounded-full bg-violet">
                  <Check size={28} />
                </div>
                <h3 className="mt-5 font-display font-600 text-2xl">Sprawdź skrzynkę!</h3>
                <p className="mt-2 text-white/60">Pierwszy rozdział jest już w drodze na Twój e-mail.</p>
              </div>
            ) : (
              <form data-testid={TESTIDS.lead.form} onSubmit={submit} className="space-y-4">
                <input
                  data-testid={TESTIDS.lead.name}
                  value={form.name}
                  onChange={update("name")}
                  placeholder="Imię"
                  className={inputCls}
                />
                <input
                  data-testid={TESTIDS.lead.email}
                  type="email"
                  value={form.email}
                  onChange={update("email")}
                  placeholder="Adres e-mail"
                  className={inputCls}
                />
                <button
                  data-testid={TESTIDS.lead.submit}
                  type="submit"
                  disabled={loading}
                  className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-violet text-white text-lg font-500 px-8 py-4 hover:bg-violet-deep disabled:opacity-70 transition-colors duration-300"
                >
                  {loading ? <Loader2 size={20} className="animate-spin" /> : "Wyślij mi darmowy rozdział"}
                </button>
              </form>
            )}
          </Reveal>
        </div>
      </div>
    </section>
  );
};
